import * as yup from "yup";

import { Translations, i18n } from "@i18n";
import { ResetPasswordFormValues } from "./types";

export const validationSchema: yup.SchemaOf<ResetPasswordFormValues> = yup.object().shape({
  newPassword: yup.string().required(i18n.t(Translations.ResetPasswordRouteNewPasswordRequired)),
  confirmPassword: yup
    .string()
    .required(i18n.t(Translations.ResetPasswordRouteConfirmPasswordRequired)),
});
